// src/components/shell/navigation.js
//
// The shell's map of the signed-in app: which top-level section each URL
// belongs to, and what to call it. Kept apart from the components so the nav,
// the document title and the tests read one list.

/**
 * Top-level sections, in nav order. `match` decides which tab is current for a
 * path — a section owns more than its own URL (the audio splitter works on a
 * library file, so it lights up Library; the storage dashboard is workspace
 * administration, so it lights up Settings).
 */
export const NAV_ITEMS = [
    {
        to: '/',
        label: 'Library',
        match: (path) => path === '/' || path.startsWith('/split/'),
    },
    {
        to: '/projects',
        label: 'Projects',
        match: (path) => path.startsWith('/projects'),
    },
    {
        to: '/tags',
        label: 'Tags',
        match: (path) => path.startsWith('/tags'),
    },
    {
        to: '/settings',
        label: 'Settings',
        match: (path) => path.startsWith('/settings') || path.startsWith('/workspace/'),
    },
    {
        to: '/admin',
        label: 'Admin',
        adminOnly: true,
        match: (path) => path.startsWith('/admin'),
    },
];

const PAGE_TITLES = [
    ['/split/', 'Split audio'],
    ['/workspace/storage', 'Storage'],
    ['/admin', 'Admin console'],
];

/** The page name for the browser tab and history entries. */
export function pageTitle(path) {
    const specific = PAGE_TITLES.find(([prefix]) => path.startsWith(prefix));
    if (specific) return specific[1];
    const section = NAV_ITEMS.find((item) => item.match(path));
    return section ? section.label : 'Page not found';
}
